import axios from 'axios';

import routes from 'app/routes';

const prepareFormDataForSend = (values) => ({
  first_name: values.firstName,
  last_name: values.lastName,
  email: values.email,
  company: values.company,
  website: values.website,
  phone: values.phone,
  jobtitle: values.jobTitle,
});

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.affiliates.prospects.index)
      .then((resp) => {
        dispatch({ type: 'LOAD', prospects: resp.data.data });
      });
  },

  create: (dispatch, values, successCallback, errorCallback) => {
    axios
      .post(routes.api.affiliates.prospects.create, {
        affiliate_prospect: { ...prepareFormDataForSend(values) },
      })
      .then((resp) => {
        dispatch({ type: 'CREATE', prospect: resp.data.data });
        successCallback();
      })
      .catch((error, _data) => {
        errorCallback(error.response.data.errors);
      });
  },

  update: (dispatch, prospectId, values, successCallback, errorCallback) => {
    axios
      .patch(routes.api.affiliates.prospects.update(prospectId), {
        affiliate_prospect: { ...prepareFormDataForSend(values) },
      })
      .then((resp) => {
        dispatch({ type: 'UPDATE', prospect: resp.data.data });
        successCallback();
      })
      .catch((error, _data) => {
        errorCallback(error.response.data.errors);
      });
  },

  delete: (dispatch, prospectId) => {
    axios
      .delete(routes.api.affiliates.prospects.destroy(prospectId))
      .then((_response) => {
        dispatch({ type: 'DELETED', prospectId });
      });
  },

};
